var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeaturesIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M44.866 17.832A4.97 4.97 0 0 0 41 16H7a4.97 4.97 0 0 0-3.866 1.832 4.977 4.977 0 0 0-1.036 4.15l2.32 11.588A8.021 8.021 0 0 0 12.262 40h23.476a8.023 8.023 0 0 0 7.844-6.43l2.32-11.588a4.974 4.974 0 0 0-1.036-4.15z",
    fill: "#327052"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 24a2 2 0 0 0-4 0v8a2 2 0 0 0 4 0v-8zM20 24a2 2 0 0 0-4 0v8a2 2 0 0 0 4 0v-8zM17.462 16l4.93-7.136c.38-.55.96-.824 1.652-.864.668 0 1.27.32 1.646.872L30.558 16h4.844l-6.41-9.386A5.998 5.998 0 0 0 24.052 4c-1.918.012-3.828.962-4.952 2.59L12.6 16h4.862z",
    fill: "#327052"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesIcon3);
export default __webpack_public_path__ + "static/media/features-icon3.d3cbe50ad7bffd0f31f5fa7bfc6b4279.svg";
export { ForwardRef as ReactComponent };